import { headerType } from 'app/features/contest/models/contest-header.models';
import type { LeaderboardColumn } from 'app/features/contest/models/leaderboard-column';
import type { LeaderboardTheme } from 'app/features/contest/models/leaderboard-theme';

export type LeaderboardMetricId = 'chrono' | 'distance' | 'ppr' | 'wpk';

export const LEADERBOARD_METRIC_LABELS: Record<LeaderboardMetricId, string> = {
  chrono: 'Durée',
  distance: 'Distance',
  ppr: 'PPR',
  wpk: 'Watts / Kg',
};

export type LeaderboardMetricOption = {
  id: LeaderboardMetricId;
  label: string;
};

export const LEADERBOARD_METRIC_OPTIONS: LeaderboardMetricOption[] = [
  { id: 'ppr', label: LEADERBOARD_METRIC_LABELS.ppr },
  { id: 'wpk', label: LEADERBOARD_METRIC_LABELS.wpk },
  { id: 'chrono', label: LEADERBOARD_METRIC_LABELS.chrono },
  { id: 'distance', label: LEADERBOARD_METRIC_LABELS.distance },
];

export type TemplateMetricConfig = {
  available: LeaderboardMetricId[];
  default: LeaderboardMetricId;
};

export type TemplateType = {
  firstTable: LeaderboardColumn[];
  hasTwoTables: boolean;
  header: headerType;
  metrics: TemplateMetricConfig;
  secondTable: LeaderboardColumn[];
  theme: LeaderboardTheme;
};
